import { CalendarCheck, Video } from "lucide-react";
import { Link } from "react-router-dom";
import { type Booking, formatMeeting, meetingTitle } from "../services/schedulerApi";

const BookingConfirmation: React.FC<{
  booking: Booking;
  heading?: string;
  showManageLink?: boolean;
  /** Called when the visitor follows the manage link. */
  onManage?: () => void;
}> = ({ booking, heading = "You're booked", showManageLink = true, onManage }) => (
  <div className="text-center py-6">
    <CalendarCheck className="w-14 h-14 text-green-600 mx-auto mb-4" aria-hidden="true" />
    <h2 className="text-2xl sm:text-3xl font-bold text-text-primary mb-2">{heading}</h2>
    <p className="text-text-secondary mb-6">
      {meetingTitle(booking)} with {booking.lead.name}
      <br />
      <strong className="text-text-primary">{formatMeeting(booking.starts_at, booking.timezone)}</strong>
    </p>
    <p className="text-text-secondary mb-6">
      A calendar invite with the details is on its way to your inbox
      {booking.guests && booking.guests.length > 0
        ? ` and to ${booking.guests.map((g) => g.name || g.email).join(", ")}.` : "."}
    </p>
    <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
      {booking.meet_url && (
        <a
          href={booking.meet_url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 font-semibold text-text-inverse hover:bg-primaryHover"
        >
          <Video className="w-5 h-5" aria-hidden="true" /> Google Meet link
        </a>
      )}
      {showManageLink && (
        <Link
          to={`/book/manage?token=${encodeURIComponent(booking.manage_token)}`}
          onClick={onManage}
          className="inline-flex items-center rounded-full border border-borderSubtle bg-white px-6 py-3 font-semibold text-text-primary hover:bg-surfaceSoft"
        >
          Reschedule or cancel
        </Link>
      )}
    </div>
  </div>
);

export default BookingConfirmation;
